import useExperience from 'canvas_states/experience/useExperience';
import useAppRouter from '../../../hooks/useAppRouter';

const useManageMyBookingCallback = () => {
  const { callbackUrl } = useAppRouter().states;
  const { experience } = useExperience().states;
  const manageMyBookingCallback = experience?.manageMyBookingCallback;

  // use the callback URL from route if it exists
  // otherwise, use callback URL that was configured in the partner config
  const url = (callbackUrl || manageMyBookingCallback?.url) ?? '';

  return {
    states: {
      showManageMyBookingBanner: Boolean(manageMyBookingCallback?.enabled && url),
      callbackUrl: url,
    },
  };
};

export default useManageMyBookingCallback;
